import { alpha } from '@mui/material/styles'
import type { Theme } from '@mui/material/styles'
import { brand } from './brand'

/** Paper lọc / form ngắn — viền + bóng nhẹ đồng bộ trang chủ (dùng trong `sx={(t) => ({ ...getFilterPaperSx(t), ... })})`) */
export function getFilterPaperSx(theme: Theme) {
  return {
    p: 2,
    mb: 3,
    borderRadius: 2,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: `0 8px 28px ${alpha(brand.navy, 0.07)}`,
  }
}

/** Vỏ bảng dữ liệu chính: dùng cho TableContainer component={Paper}.
 *  - overflowX:auto để bảng nhiều cột tự cuộn ngang, không tràn viewport.
 *  - width/maxWidth 100% chặn parent container bị đẩy vượt khung.
 */
export function getTablePaperSx(theme: Theme) {
  return {
    borderRadius: 2,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: `0 10px 30px ${alpha(brand.navy, 0.08)}`,
    width: '100%',
    maxWidth: '100%',
    overflowX: 'auto' as const,
    overflowY: 'hidden' as const,
  }
}

/** Paper nội dung (khối thống kê, panel chi tiết) */
export function getContentPaperSx(theme: Theme) {
  return {
    p: 3,
    borderRadius: 2,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: `0 10px 28px ${alpha(brand.navy, 0.08)}`,
  }
}

/** Card đồng bộ nhận diện — viền nhẹ, bóng mềm */
export function getCardSurfaceSx(theme: Theme) {
  return {
    borderRadius: 2,
    border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
    boxShadow: `0 10px 30px ${alpha(brand.navy, 0.08)}`,
    transition: 'box-shadow 0.2s ease, transform 0.2s ease',
    '&:hover': {
      boxShadow: `0 14px 34px ${alpha(brand.navy, 0.12)}`,
      transform: 'translateY(-1px)',
    },
  }
}
